import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UtilService } from '../../services/util.service';

@Component({
  standalone: false,
  selector: 'app-date-filter',
  templateUrl: './date-filter.component.html',
  styleUrl: './date-filter.component.scss'
})
export class DateFilterComponent {

  @Input() fromDate: any;
  @Input() toDate: any;
  @Output() dateSelected = new EventEmitter<{ fromDate: any, toDate: any }>();

  placeHolder = 'DD/MM/YYYY';
  minStart: any;
  showClear = false;

  constructor(
    private _util: UtilService
  ) {

  }

  ngOnInit() {
  }

  onClear() {
    const vm = this;
    vm.fromDate = null;
    vm.toDate = null;
    vm.showClear = false;
    vm.dateSelected.emit({ fromDate: null, toDate: null });
  }

  onFromDate(event: any) {
    const vm = this;
    vm.minStart = vm._util.getMinFormat(event);
  }

  onSubmit() {
    const vm = this;
    const dateRange = {
      fromDate: vm.fromDate,
      toDate: vm.toDate
    };
    vm.showClear = true;
    vm.dateSelected.emit(dateRange);
  }

}
